import {
  DispatchStopPickupPopupInfo,
  DispatchUnassignedPickupPopupInfo,
} from "../../../../../mapComponents/Popups";
import {
  getPickupStopData,
  isPickupDriverExistInGrid,
} from "../utils";
import { hasStopDelayed } from "../../utils";
import { isGroupHeaders } from "../../Pickups/GroupPickup/utils";

const PickupPopupInfo = ({
  specialNeeds,
  routesData,
  selectedPickup,
  showAction = false,
  enableChangePickupTerminal=false,
  terminal,
  routesList,
  currentActiveRoutes,
  unAssignDriver = "",
  openMessageChatBox = "",
  onRecommendationsButtonClick = "",
  terminalCodeList = [],
  glEventHub = "",
  closingSoonLimitConfig,
  enqueueSnackbar,
  marker,
  showPickupHistory = true,
  enableBulkEditAndVoid = false
}) => {
  const { offset, code } = terminal;
  const stopData = getPickupStopData(routesList, selectedPickup).stopData;
  const hideTerminalChange =
    selectedPickup.isCompleted ||
    selectedPickup.isVoided ||
    selectedPickup.isMissed ||
    !enableChangePickupTerminal || isGroupHeaders(selectedPickup);
  const commonProps = {
    hideAction: !showAction || selectedPickup.driverId,
    specialNeeds,
    glEventHub,
    showPickupHistory,
    enableBulkEditAndVoid
  };
  return (
    <>
      {isPickupDriverExistInGrid({
        currentActiveRoutes,
        driverId: selectedPickup.driverId,
        routeId: selectedPickup.routeId
      }) ? (
        <DispatchStopPickupPopupInfo
          {...commonProps}
          stopData={stopData}
          unAssignDriver={unAssignDriver}
          pickupNumber={selectedPickup.pickupNumber}
          isDelayStop={hasStopDelayed(stopData)}
          routesData={routesData}
          terminalOffset={offset}
          openDriverChat={openMessageChatBox}
          closingSoonLimitConfig={closingSoonLimitConfig}
          pickupId={selectedPickup.pickupId}
        />
      ) : (
        <DispatchUnassignedPickupPopupInfo
          {...commonProps}
          onButtonClicked={onRecommendationsButtonClick}
          data={{ data: selectedPickup }}
          hideTerminalChange={hideTerminalChange}
          terminalOptions={terminalCodeList}
          activeTerminal={code}
          enqueueSnackbar={enqueueSnackbar}
          terminalOffset={offset}
          markerComponent={marker}
          closingSoonLimitConfig={closingSoonLimitConfig}
        />
      )}
    </>
  );
};

export default PickupPopupInfo;
